import { useState, useEffect } from 'react';
import { getMaintenanceMode } from '~/api/maintenance';

export const useMaintenanceMode = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  useEffect(() => {
    getMaintenanceMode()
      .then(setIsMaintenanceMode)
      .catch(() => setIsMaintenanceMode(false))
      .finally(() => setIsLoading(false));

    const handleMaintenanceEvent = () => {
      setIsMaintenanceMode(true);
    };
    window.addEventListener('maintenance-mode', handleMaintenanceEvent);
    return () => window.removeEventListener('maintenance-mode', handleMaintenanceEvent);
  }, []);

  return { isLoading, isMaintenanceMode };
};
